<template>
<div class="d-flex h-100 p-3 mx-auto flex-column coverContainer">
  <main class="inner cover">
    <div class="container-fluid h-100">
      <div class="row h-100 align-items-center">
        <div class="card col-4 offset-2" >
          <h1 class="font-color-primary" style="font-size: 60px;">OAuthAdmin</h1>
          <p style="text-align: justify;">
            Administrador de la plataforma de de autenticacion para productos Medisoft, la cual permite interoperabilidad
            entre todos sus sistemas, servicios o plataformas con tan solo una cuenta de usuario en comun.
            <br><br>
            OAuth by Medisoft es un proyecto de codigo cerrado desarrollado bajo tecnologias de ultima generacion y
            reactivas completamente, que permite la seguridad absoluta en cada comunicacion de los servicios de Medisoft,
            recuerda que para poder acceder <strong>necesitas una cuenta de desarrollador de Medisoft</strong>, las cuentas
            regulares no funcionan para autenticarse dentro del administrador de la plataforma y unicamente funcionan en
            productos o servicios autorizados.
          </p>
          <button class="btn btn-primary btn-sm" @click.prevent="openTab"><i class="fab fa-windows"></i> Descargar ultima version</button>
          <button v-if="this.$router.history._startLocation !== '/download'" class="btn btn-link btn-sm" @click.prevent="returnBack">Regresar</button>
          <span></span>
        </div>
        <div class="col-4">
          <img src="../assets/logo.png" style="width: 100%;">
        </div>
      </div>
    </div>
  </main>
  </div>
</template>

<script>
export default {
  name: 'Download',
  computed: {
    appHeight () {
      return this.$store.state.app.height
    },
    appWidth () {
      return this.$store.state.app.width
    }
  },
  methods: {
    openTab () {
      window.open('https://authentication.medisoftcolombia.com/releases/OAuthAdminSetup_1.0.0_win32.exe', '_blank')
    },
    returnBack () {
      this.$router.push({ path: this.$router.history._startLocation })
    }
  }
}
</script>

<style scoped>
.card {
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  padding: 10px 40px;
}
</style>
